import { ClerkUserRole } from '@/types/auth'
import { useUser } from '@clerk/clerk-react'

export type RoleData = {
  readonly userRole?: ClerkUserRole
  readonly isLoaded: boolean
  readonly hasRole: boolean
}

export function useRole(): RoleData {
  const { user, isLoaded } = useUser()

  if (!isLoaded) {
    return {
      userRole: undefined,
      isLoaded: false,
      hasRole: false,
    }
  }

  if (!user) {
    return {
      userRole: undefined,
      isLoaded: true,
      hasRole: false,
    }
  }

  // Extract role from organization membership (Clerk adds 'org:' prefix)
  const roleFromOrg = user.organizationMemberships?.[0]?.role as ClerkUserRole

  // Validate that it's a known role
  const hasValidRole = Object.values(ClerkUserRole).includes(roleFromOrg)

  return {
    userRole: hasValidRole ? roleFromOrg : undefined,
    isLoaded: true,
    hasRole: hasValidRole,
  }
}

export function useIsClientAdmin(): boolean {
  const { userRole, isLoaded } = useRole()
  return isLoaded && userRole === ClerkUserRole.CLIENT_ADMIN
}
